<template>
  <vx-card title="填写用户信息">
    <vx-form class="w-full" layout="v" label-align="top" v-slot="{invalid, handleSubmit}">
      <form-item label="角色" label-align="none">
        {{$s.dict.roleName[form.roleID]}}
      </form-item>
      <form-item required label="手机号">
        <vs-input class="w-full" placeholder="请输入手机号" v-model="form.phone" @input="handlePhone" />
      </form-item>
      <form-item label="用户名" rules="required" :msgs="{required: '用户名必填'}">
        <vs-input class="w-full" data-vv-name="username" placeholder="请输入用户名" v-model="form.userName" />
      </form-item>
      <form-item required label="密码" help="请输入数字、字母" v-if="isNew">
        <vs-input class="w-full" placeholder="请输入密码" v-model="form.password" />
        <vs-button size="small" type="border" class="mt-1" @click="genRandomPassword">生成随机密码</vs-button>
      </form-item>
      <form-item required label="渠道商到期时间" label-align="top" v-if="form.roleID == 3">
        <date-picker v-model="form.channelExpire" />
      </form-item>
      <form-item label="性别" label-align="none">
        <vs-radio v-model="form.sex" vs-name="sex" vs-value="1">男</vs-radio>
        <vs-radio v-model="form.sex" vs-name="sex" vs-value="2">女</vs-radio>
      </form-item>
      <form-item label="头像">
        <upload
          fileName="file"
          v-model="form.avatarUrl"
          data-vv-name="installer"
          automatic
          text="上传"
          accept=".jpg,.png"
          action="/admin/v1/file/upload"
          :single-upload="true"
          :limit="1"
        />
      </form-item>
      <form-item label="昵称">
        <vs-input class="w-full" placeholder="请输入昵称" v-model="form.nickName" />
      </form-item>

      <form-item label="邮箱" rules="email">
        <vs-input class="w-full" placeholder="请输入邮箱" v-model="form.email" />
      </form-item>
      <!--<form-item label="生日">
          <date-picker v-model="form.birthday" />
        </form-item>
        <form-item label="地址" class="w-full mt-5">
          <vs-input class="w-32 inline-block mr-1 mb-1" placeholder="国家" v-model="form.country" />
          <vs-input class="w-32 inline-block mr-1 mb-1" placeholder="省份" v-model="form.province" />
          <vs-input class="w-32 inline-block mr-1 mb-1" placeholder="城市" v-model="form.city" />
          <vs-input class="w-64 inline-block mr-1 mb-1" placeholder="地址" v-model="form.address" />
        </form-item>-->
      <form-item>
        <vs-button class="mr-3 mb-2" :disabled="invalid" @click="handleSubmit(submitForm)">提交</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="$router.push('/user/list/' + routeName[form.roleID])">返回</vs-button>
      </form-item>
    </vx-form>
  </vx-card>
</template>
<script>
export default {
  data() {
    return {
      form: {
        roleID: 5,
        password: '',
      },
    }
  },
  computed: {
    isNew() {
      return !this.$route.params.id
    },
    roles() {
      const roles = [...this.$s.dict.roles]
      return roles
    },
    routeName() {
      return {
        1: 'admin',
        2: 'admin',
        3: 'channel',
        4: 'channel',
        5: 'user',
      }
    }
  },
  async mounted() {
    if (!this.isNew) {
      const user = await this.$s.user.detail(this.$route.params.id)
      this.form = {
        ...user,
        channelExpire: user.channelExpire ? new Date(user.channelExpire) : undefined,
      }
    } else {
      this.form.roleID = Number(this.$route.query.roleID) || 5
    }
  },
  methods: {
    genRandomPassword() {
      this.form.password = Math.random().toString(36).substr(2)
    },
    handlePhone(e) {
      this.form.userName = e
    },
    async submitForm() {
      
      const preuser = {
        ...this.form,
        sex: Number(this.form.sex) || 0,
        // avatarUrl: this.form.avatarUrl && this.form.avatarUrl.length ? this.form.avatarUrl[0] : '',
      }
      let user
      if (this.isNew) {
        user = await this.$s.user.create(preuser)
        this.$notify({
          title: '创建用户成功'
        })
      } else {
        user = await this.$s.user.update(preuser)
        this.$notify({
          title: '用户资料更新成功'
        })
      }

      this.$router.push('/user/list/' + this.routeName[this.form.roleID])
    },
  }
}
</script>